export default {
  header: 'Preset repository',
};
